import { render, staticRenderFns } from "./VisualizarIntimacoes.vue?vue&type=template&id=6fc6371e&scoped=true"
import script from "./VisualizarIntimacoes.vue?vue&type=script&lang=js"
export * from "./VisualizarIntimacoes.vue?vue&type=script&lang=js"
import style0 from "./VisualizarIntimacoes.vue?vue&type=style&index=0&id=6fc6371e&prod&scoped=true&lang=css"
import style1 from "./VisualizarIntimacoes.vue?vue&type=style&index=1&id=6fc6371e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6371e",
  null
  
)

export default component.exports